import { call, put, takeLatest } from 'redux-saga/effects';

import * as url from '../../helpers/url_helper';

// Crypto Redux States
import { purchaseOrdersTypes } from './actionTypes';
import { getPurchaseOrdersListSuccess, getPurchaseOrdersListFail, getMilestoneConfigPOSuccess, getMilestoneConfigPOFail } from './actions';
import { getMilestoneConfigOperation } from '../../helpers/GetMilestoneConfigOperation';

let controller = new AbortController();
let signal = controller.signal;

export const cancelFetchPO = () => {
  controller.abort(); // Esto cancelará la solicitud
  controller = new AbortController(); // Restablecer el controlador para futuras solicitudes
  signal = controller.signal; // Actualizar la señal para futuras solicitudes
};

export const fetchPurchaseOrders = async (data: any) => {
    const { from, to, order, dynamicFilter, dynamicFilterCF } = data.form;
    const { sizePerPage, page } = data.pagination;

    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query {
    GetPurchaseOrders(PurchaseOrders: {
      userId: ${user.id || ''},
      initial_date: "${from || ''}",
      final_date: "${to + ' 11:59:00' || ''}",
      order : "${order}",
      ${dynamicFilterCF}
      ${dynamicFilter}
      }, Pagination:{
        sizePage:${sizePerPage},
        actualPage:${page}
      })
      {
        purchaseOrdersData {
          id
          initial_date
          final_date
          clientId
          Number 
          CreatedOn
          CreatedByName
          Version
          Status
          BuyerName
          SellerName 
          TotalAmountInCurrency
          ItemsAmountInCurrency 
          ChargesAmountInCurrency
          TaxAmountInCurrency
          TotalAmount
          ItemsAmount
          ChargesAmount 
          TaxAmount
          TotalWeight
          TotalVolume
          TotalTradeDiscount
          TotalTradeDiscountInCurrency
          ExchangeRate
          CreatorNetworkID
          TotalPieces
          IsAcceptedBySeller
          IsOnline
          IsCancelled

          ApprovedByName
          DocumentTemplateName
          Notes
          PaymentTerms
          ReferenceNumber
          IsOnlineTransaction    
          IsTrackingEmailSent          
          LastLineID
          LengthPrecision    
          LengthUnit    
          VolumePrecision      
          VolumeUnit      
          VolumeWeightPrecision        
          WeightPrecision    
          WeightUnit
          VolumeWeightUnit
          JOBNumber

          GUID
          customFields {
            name
            value
            internalName
          }        
       }
       CountItems
      }
  }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
        signal
    }).then((res) => res.json());
    return response.data.GetPurchaseOrders;
};

function* fetchPurchaseOrdersSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchPurchaseOrders, data.payload);
        yield put(getPurchaseOrdersListSuccess(response));
    } catch (error) {
        yield put(getPurchaseOrdersListFail(error));
    }
}

function* getMilestoneConfigPO(data: any): any {
  try {
    const response: Promise<any> = yield call(getMilestoneConfigOperation, {
      OperationType: "PO",
      ...data.payload,
    });
    yield put(getMilestoneConfigPOSuccess(response));
  } catch (error) {
    yield put(getMilestoneConfigPOFail(error));
  }
}

function* PurchaseOrdersSaga() {
    yield takeLatest(purchaseOrdersTypes.GET_PURCHASE_ORDERS_DEFINITIONS, fetchPurchaseOrdersSaga);
    yield takeLatest(purchaseOrdersTypes.GET_MILESTONESCONFIG_PO,getMilestoneConfigPO)
}

export default PurchaseOrdersSaga;
